import React, { useMemo } from 'react';
import { format } from 'date-fns';
import { MultipleStaffShiftSelectionContextProvider } from './schedule/staff/MultipleStaffShiftSelection';
// Import the main implementation
// @ts-ignore
import ScheduleInternals from './HospitalSchedule.jsx';

// Re-export for backward compatibility
export { EditingHeader, Row, HospitalName } from './schedule/styled';
export { formats } from './schedule/constants';

interface HospitalScheduleProps {
  scope?: any;
  isSuperAdmin: boolean;
  isGroupAdmin: boolean;
  isMonitoringEngineer: boolean;
  isPreOPNurse: boolean;
  isNursing: boolean;
  isAdmin: boolean;
  isFrontDesk: boolean;
  isOperationsManager: boolean;
  isAnesthesiologist: boolean;
  isScheduleUser: boolean;
  isKiosk: boolean;
  config?: any;
  hasScheduleAccessAllRight: boolean;
  date: Date;
  physician?: number;
  location: any;
  history: any;
  parsedParams: any;
  match: any;
  dayIsOver?: boolean;
}

/**
 * HospitalSchedule - TypeScript wrapper for the schedule application
 *
 * This wrapper provides:
 * - Type-safe props interface
 * - Context provider for shared state
 * - Delegates to the old component for rendering
 *
 * Critical bugs have been fixed in:
 * - Apollo cache configuration (cache-first policies)
 * - Patient status updates (now instant)
 * - Procedure denormalization (no stale closures)
 *
 * Future: Extract components incrementally from HospitalSchedule_old.jsx
 */
const HospitalSchedule: React.FC<HospitalScheduleProps> = props => {
  const { date } = props;

  // Format date for context provider
  const formattedDate = useMemo(() => format(date, 'YYYY-MM-DD'), [date]);

  return (
    <MultipleStaffShiftSelectionContextProvider date={formattedDate}>
      <ScheduleInternals {...props} />
    </MultipleStaffShiftSelectionContextProvider>
  );
};

export default HospitalSchedule;
